import { searchConstants } from 'commons/constants';

const { TEXT_ANSWER_LIMIT } = searchConstants;

const isDropdown = (options: Record<string, any>[] = []) =>
  options.length > 1 && options.length <= TEXT_ANSWER_LIMIT;

export default isDropdown;
